





const getUserId = () => {
  let userId = localStorage.getItem('user_id');

  if (!userId) {
    userId = crypto.randomUUID();
    localStorage.setItem('user_id', userId);
  }

  return userId;
};


function setCookie(name, value, maxAgeSeconds) {
  document.cookie = `${name  }=${  value  }; max-age=${  maxAgeSeconds  }; path=/`;
}

function getCookie(name) {
  const cookies = document.cookie.split('; ');
  for (let c of cookies) {
    const parts = c.split('=');
    const key = parts[0];
    const val = parts[1];
    if (key === name) {return val;}
  }
  return null;
}


export const onRouteUpdate = (args) => {
  if (!args || !args.location) return;

  const location = args.location;

  const userId = getUserId();

  const params = new URLSearchParams(location.search || '');
  const company = params.get('track');

  if (!company) return;

  const cookieName = 'tracked_' + company + '_' + userId;
  const alreadyTracked = getCookie(cookieName);

  if (!alreadyTracked) {
    fetch(`${process.env.GATSBY_API_URL}/api/logVisit`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        userId: userId,
        company: company,
      }),
    });
    const storageKey = "company";
    setCookie(cookieName, 'true', 300);
    localStorage.setItem(
      storageKey,
      JSON.stringify({
        userId,
        company,
        trackedAt: new Date().toISOString(),
      })
    );
  }
};
